
import Button from '../../../components/base/Button';

export default function CTASection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-r from-[#00D9FF] to-[#0099FF] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 bg-white/5 rounded-full animate-bounce"></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-white/10 rounded-full animate-ping"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Ready to Secure Your Connection?
        </h2>
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
          Join ELTROM VPN and experience true digital freedom with military-grade 
          encryption and lightning-fast speeds.
        </p>
        
        <div className="relative inline-block">
          <Button
            variant="dark"
            size="lg"
            onClick={() => scrollToSection('contact')}
            className="relative bg-black text-white hover:bg-gray-800 pl-16 pr-8 py-6 text-xl font-bold group overflow-hidden"
          >
            {/* Orange Badge */}
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center">
              <i className="ri-shield-check-line text-white text-lg"></i>
            </div>
            
            START NOW
            <i className="ri-arrow-right-line ml-3 group-hover:translate-x-1 transition-transform duration-200"></i>
            
            {/* Hover Effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-gray-800 to-gray-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
          </Button>
        </div>

        {/* Trust Indicators */}
        <div className="mt-12 flex flex-wrap justify-center items-center gap-8 text-white/80">
          <div className="flex items-center space-x-2">
            <i className="ri-shield-check-line text-xl"></i>
            <span className="font-medium">256-bit Encryption</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-global-line text-xl"></i>
            <span className="font-medium">50+ Server Locations</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-customer-service-line text-xl"></i>
            <span className="font-medium">24/7 Support</span>
          </div>
        </div>
      </div>
    </section>
  );
}
